<template>
<div id="booking-widget">
  <div class="container bv-example-row room-list vue-content-body">
   <div class="reserveport-iframe-wrap">
    <div class="row" v-show="!pageloader">
    <div class="col-md-4"></div>
    <div class="col-md-4">
      <loader-terms></loader-terms>
    </div>
    <div class="col-md-4"></div>
  </div>
   <div class="row" v-if="pageloader">
     <div class="col-md-9 col-sm-12 col-12">
        <div class="row spinner-cover">
          <div class="notify-container" role="alert" style="min-height: 16px;">
            <div class="notify-icon">
                <span class="fa fa-money"></span>
            </div>
            <h4 class="notify-title">Pay Now</h4>
            <div class="notify-text" aria-role="alert">
                To complete your reservation with reference number {{paymentData.referenceNumber}}, please proceed with the payment. Please note that you have <span class="timerspan" id="minutes"></span> <span class="timerspan">minutes</span> &nbsp;<span class="timerspan" id="seconds"></span> <span class="timerspan">seconds</span> to complete the payment else your reservation will be automatically cancelled.<br><br>
                <span v-if="displayCardMessage == 1"><strong>NOTE: </strong>For card payments, you will be required to produce the card used to make the payment during check-in.</span>
            </div>
        </div>
              <div class="spinner"  v-show="!spinner">
               <i class="fa fa-spinner fa-spin " style="font-size:48px;color:#ff6600"></i>
              </div>
              <iframe
                :src="iframe"
                width="100%"
                height="1000px"
                scrolling="auto"
                frameBorder="0"
                v-on:load="iframeLoading"
              >
                <p>Browser unable to load iFrame</p>
              </iframe>
        </div>

     </div>
      <div class="col-md-3 col-sm-12 col-12">
         <div class="vue-right-side">
          <div class="row">
            <div class="col-md-12 col-sm-12 col-12">
              <div class="side_top_card">
                {{paymentData.name}}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-12 col-12">
              <div class="side_bottom_card">
                <h3>SUMMARY</h3>
                 <div class="row">
                  <div class="col-md-2">
                     <img id="bedimg"  :src="'https://reservations.reserveport.com/static/img/logo.png'" width="56">
                    <!-- <img :src="'https://reservations.reserveport.com/static/img/logo.png'" width="45" class="img-responsive"> -->
                  </div>
                  <div
                    class="header-content col-md-10 ol-sm-12 col-12"
                    style="text-align: left !important"
                  >
                   <span><strong>Adult:</strong> {{occupancy.totalNoOfAdults}} <br /></span>
                    <span v-if="occupancy.totalNoOfChildren > 0"><strong>Children:</strong> {{occupancy.totalNoOfChildren}} <br></span>
                    <span><strong>Check-in:</strong>&nbsp;{{ occupancy.checkin_date }} <br /></span>
                    <span><strong>Check-out:</strong>&nbsp;{{ occupancy.checkout_date }} <br /></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 col-sm-12 col-12">
                    <div>
                      <table
                        id="room_details_1"
                        class="table table-small-font  table-responsive mrgb5"
                      >
                        <thead>
                          <tr>
                            <th  style="text-align: left" width="10%">{{roomLabel.singular}} details</th>
                            <th  width="10%" style="text-align: right">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(room, roomkey) in paymentData.rooms" :key="roomkey">
                            <td  width="10%" class="prclabel">
                              {{ room.name }}
                            </td>
                             <td  width="10%" valign="middle" style="text-align: right">
                                <span>
                                 {{paymentData.currency }}
                                  {{ formatPrice(room.price) }}
                               </span>
                            </td>
                          </tr>
                          <tr v-if="paymentData.totalDiscount != 0">
                            <td  width="10%" class="prclabel">Discount</td>
                            <td  width="10%" valign="middle" style="text-align: right">
                              <span>
                                {{paymentData.currency}}
                                {{ formatPrice(paymentData.totalDiscount) }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-if="paymentData.enhancements != 0">
                      <table
                        class="table table-small-font  table-responsive mrgb5"
                      >
                        <thead>
                          <tr>
                            <th  style="text-align: left"  width="10%">Enhancement Details</th>
                            <th  width="10%"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(adhance, index) in paymentData.enhancements"
                            :key="index"
                          >
                            <td  width="10%" class="prclabel">
                              {{ adhance.name }}
                            </td>
                            <td  width="10%" style="text-align: right">
                               <span>{{paymentData.currency }}</span>&nbsp;{{
                                formatPrice(adhance.price)
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div>
                      <table
                        class="table table-small-font  table-responsive mrgb5"
                      >
                        <tbody>
                          <tr v-if="paymentData.totalServiceCharge > 0">
                            <td  width="10%" class="prclabel"><b> SERVICE CHARGES?</b></td>
                            <td  width="10%" valign="middle" style="text-align: right">
                              <span>{{paymentData.currency}}</span>
                              <span>{{ formatPrice(paymentData.totalServiceCharge) }}</span>
                            </td>
                          </tr>
                          <tr v-if="paymentData.totalVAT > 0">
                            <td  width="10%" class="prclabel"><b> TOTAL VAT?</b></td>
                            <td  width="10%" valign="middle" style="text-align: right">
                               <span>{{paymentData.currency}}</span>
                              &nbsp; <span>{{ formatPrice(paymentData.totalVAT) }} </span>
                            </td>
                          </tr>
                          <tr v-if="paymentData.totalHotelTax > 0">
                            <td  width="10%" class="prclabel"><b>{{hotelTax}}</b></td>
                            <td  width="10%" valign="middle" style="text-align: right">
                                <span>{{paymentData.currency }}</span>
                                 &nbsp;<span>{{
                                formatPrice(paymentData.totalHotelTax)
                              }}</span>
                            </td>
                          </tr>
                          <tr v-if="extraCharges.gateway_fee_enabled ==1 && paymentData.totalGatewayFee > 0">
                            <td  width="10%" class="prclabel"><b>Gateway Fee</b></td>
                            <td  width="10%" valign="middle" style="text-align: right">
                                <span>{{paymentData.currency }}</span>
                                 &nbsp;<span>{{
                                formatPrice(paymentData.totalGatewayFee)
                              }}</span>
                            </td>
                          </tr>
                          <tr class="pricetotal">
                            <td  width="10%" class="pricelabel">Total:</td>
                            <td  width="10%">
                              <div id="finalPrice">
                                <span>{{paymentData.currency }}</span>
                                &nbsp; <span>{{ formatPrice(paymentData.totalAmountPayable) }}</span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
         </div>
        </div>
   </div>
   </div>
</div>
</div>
</template>
<script>
import loader from '../components/loader.vue'
import reusableData from '../components/mixins/reusableData'
import { pushPlatformEvent, toAmount, groupRoomItems } from '../utils/ecommerce'
export default {
  name: 'App',
  components: {
    'loader-terms': loader
  },
  data () {
    return {
      pageloader: false,
      bookingData: '',
      paymentData: [],
      paymentType: '',
      propertyid: '',
      iframe: '',
      spinner: this.$store.state.spinner,
      referenceNumber: '',
      totalRoomPrice: '',
      chargeType: '',
      consumerKey: '',
      occupancy: '',
      extraCharges: '',
      hotelTax: '',
      displayCardMessage: '',
      roomLabel: ''
    }
  },
  created () {
    this.iframe = ''
    window.addEventListener('load', this.reloadingIframe())
    this.setexitTimeout()
    setTimeout(() => this.$router.push({path: '/'}), 900000)
  },
  methods: {
    trackAddPaymentInfo (data) {
      pushPlatformEvent('add_payment_info', {
        hotel_id: this.propertyid,
        hotel_name: data.name,
        currency: data.currency,
        value: toAmount(data.totalAmountPayable),
        items: groupRoomItems(data.rooms)
      })
    },
    //  method to redirect to home after xxxx time
    setexitTimeout () {
      var countDownDate = new Date().getTime() + 15 * 60 * 1000
      var x = setInterval(function () {
        // Get today's date and time
        var now = new Date().getTime()

        // Find the distance between now and the count down date
        var distance = countDownDate - now

        // Time calculations for hours, minutes and seconds
        // var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        var seconds = Math.floor((distance % (1000 * 60)) / 1000)
        // Display the result in the element with id="demo"
        if (document.getElementById('minutes') !== null) {
          document.getElementById('minutes').innerHTML = minutes
        }
        if (document.getElementById('seconds') !== null) {
          document.getElementById('seconds').innerHTML = seconds
        }
        // If the count down is finished, redirect to booking
        if (minutes === 0 && seconds === 0) {
          clearInterval(x)
        }
      }, 1000)
    },
    async reloadingIframe () {
      let hash = document.location.hash
      let urlparameters = hash.split('?')[1]
      let propid = urlparameters.split('&')[0]
      let urldata = urlparameters.split('&')[1]
      let encryptedUrlData = urldata.split('=')[1]
      let reconstructedData1 = encryptedUrlData.split('%3D')
      let reconstructedData = reconstructedData1.join('=')
      // var reference =
      let encodedpid = propid.split('=')[1]
      let reconstructedpid1 = encodedpid.split('%3D')
      let reconstructedpid = reconstructedpid1.join('=')
      this.propertyid = atob(reconstructedpid)

      const configUrl = process.env.CONFIG_URL['live_url']
      const key = process.env.PMS_KEY['key']
      const config = {
        headers: { 'Accept': 'application/json' }
      }
      const payload = {
        'property_id': this.propertyid,
        'api': this.type
      }
      const configRes = await this.$http.post(configUrl, payload, config)
      if (configRes.status === 200) {
        let configData = this.CryptoJSAesDecrypt(key, configRes.data.property_details)
        configData = JSON.parse(configData)
        const passkey = configData[0].val_ptoken// process.env.SECRET_KEY[this.propertyid].key
        let consumerKey = configData[0].val_reserveport_secret_key// process.env.CONSUMER_KEY[this.propertyid].key
        const details = JSON.parse(configData[0].add_details)
        let fetchUrl = details.url
        var propertyPesapalKey = configData[0].val_pesapal_Key// process.env.CONSUMER_PESAPAL_KEY[this.propertyid].key
        var propertyPesapalSecret = configData[0].val_pesapal_Secret// process.env.CONSUMER_PESAPAL_SECRET[this.propertyid].secret
        //
        this.propertyid = atob(reconstructedpid)
        let decryptedurlparamData = this.CryptoJSAesDecrypt(passkey, atob(reconstructedData))
        let jsonparseDecryptedData = JSON.parse(decryptedurlparamData)
        this.referenceNumber = jsonparseDecryptedData.reference
        this.displayCardMessage = jsonparseDecryptedData.displayCardMessage
        this.chargeType = jsonparseDecryptedData.chargeType
        if (this.chargeType === 'full') {
          this.paymentType = 'full'
        } else {
          this.paymentType = 'deposit'
        }
        const postData = {
          reference_number: this.referenceNumber
        }
        var postDataJson = JSON.stringify(postData)
        var encryptedData = this.CryptoJSAesEncrypt(passkey, postDataJson)
        var url = `${fetchUrl}/index.php?option=com_goreserva_psearch&task=api.fetchReservation&pid=${this.propertyid}&pk=${propertyPesapalKey}&ps=${propertyPesapalSecret}&consumer_key=${consumerKey}&data=${encryptedData}`
        this.axios
          .get(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then((response) => {
            var responseData = response.data.er
            var decryptedData = this.CryptoJSAesDecrypt(passkey, responseData)
            return JSON.parse(decryptedData)
          })
          .then((data) => {
            this.paymentData = data
            this.roomLabel = data.room_label
            var iframe = atob(data.iframeLink)
            this.iframe = iframe
            this.occupancy = data.occupancy
            this.extraCharges = data.extra_charges
            this.hotelTax = data.extra_charges.hotel_tax.name
            this.pageloader = true
            this.trackAddPaymentInfo(data)
          }).catch((error) => {
            console.log('error', error.data)
          })
      }
    },
    iframeLoading () {
      this.spinner = true
    }
  },
  mixins: [reusableData]
}
</script>

<style scoped>
#booking-widget .vue-right-side{
  position: -webkit-sticky !important;
  position: sticky !important;
  top: 0
}
/* styling spinner */
#booking-widget .spinner-cover {
  position: relative;
}
#booking-widget .spinner{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000000;
}
/* end */
/* style for alert */
#booking-widget .notify-container {
    background-color: #642609 !important;
    background-image: none !important;
    border: none !important;
    -moz-border-radius: 3px;
    -webkit-border-radius: 3px;
    border-radius: 3px;
    padding: 10px;
    margin-bottom: 25px;
    box-shadow: 0 6px 28px 0 rgba(0,0,0,.1);
}
#booking-widget .notify-container .fa {
    display: inline-block;
    font: normal normal normal 24px/1 FontAwesome !important;
    margin: 0 3px;
    width: 24px;
    height: 24px;
    font-size: 24px;
    color: #d4984b;
}
#booking-widget .notify-icon, .notify-icon span {
    display: block;
    float: left;
    margin-right: .2em;
}

#booking-widget .timerspan{
  color: #d4984b !important;
}
#booking-widget .notify-title {
    display: block;
    margin-bottom: .4em;
    margin-top: 0;
    text-transform: uppercase;
    padding-left: 40px !important;
    color: #d4984b !important;
    text-rendering: geometricPrecision !important;
    font-weight: 600;
    font-size: 14px !important;
}
#booking-widget .notify-text {
    color: #FFF !important;
    padding-left: 40px !important;
    text-rendering: geometricPrecision !important;
    display: block;
    line-height: 18px;
}
/* endstyle for update */
#booking-widget #deposit_amount{
  background-color: #EFEFEF;
  /* margin-bottom:25px; */
  padding:10px;
}
#booking-widget .active {
  background-color: darkgray;
  color: white;
  padding:10px;
}
#booking-widget .vue-content-body {
  margin-top: 5em;
  margin-bottom: 5em;
  line-height: normal !important;
  font-size: 14px !important;
}
#booking-widget .header-content {
  padding-left: 30px;
}
.slide-fade-enter-active {
  transition: all 0.1s ease;
}
#bedimg{
  max-width: auto!important;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.side_bottom_card,
.side_top_card {
  border: 1px solid #dedede;
  padding: 10px;
  text-align: center;
  background-color: #fbfbfb;
}

.side_top_card {
  margin-bottom: .8em;
}

.side_top_card h3,
.side_bottom_card h3 {
  font-size: 20px;
  font-weight: 500;
  border-bottom: 1px dotted #dedede;
  padding-bottom: 15px;
  text-align: center;
  color: #555;
  text-transform: uppercase;
  margin-top: 0;
}

#booking-widget table.table-small-font {
  font-size: 12px;
  -webkit-text-size-adjust: none;
  line-height: 1.5em;
}
#booking-widget .prclabel {
  text-align: left !important;
  font-size: 10px;
  text-transform: uppercase;
  white-space: nowrap;
  font-weight: 600;
}
#booking-widget .table td.pricelabel,
#booking-widget .table td.statuslabel {
  text-align: left !important;
  font-size: 10px;
  text-transform: uppercase;
  background: #eee;
  white-space: nowrap;
  font-weight: 600;
}
#booking-widget .side_bottom_card .pricetotal td {
  font-weight: 600;
  background: #dedede;
  text-align: right;
}
@media only screen and (max-width: 600px) {
 #booking-widget .content-body {
  margin-left: 50px;
  margin-right: 50px;
}
}
@media only screen and (min-width: 600px) {
  #booking-widget .content-body {
  margin-left: 50px;
  margin-right: 50px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/payment.vue